import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from '../../../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js';
import style from './InfoBadge.module.css.js';

const InfoBadge = ({ superTitle, title, description, cta, standalone }) => {
    return (jsxs("div", { className: classNames(style.container, standalone && style.standalone), children: [jsxs("div", { className: style.titleContainer, children: [jsx("div", { className: style.superTitle, children: superTitle }), jsx("div", { className: style.title, children: title }), jsx("div", { className: style.description, children: description })] }), jsx("div", { className: style.cta, children: cta })] }));
};

export { InfoBadge };
//# sourceMappingURL=InfoBadge.js.map
